import {baseURL} from "@/services/HttpService";

let viewUrl = `${baseURL}/attachment?fileName=`; // 附件查看路径

export const changeToAbsImgPath = (info) => {
  let fileList = [...info.fileList];

  fileList = fileList.map(file => {
    if (file.response) {
      file.url = viewUrl + file.response.data;
    }
    return file;
  }).filter(file => file.url);
  return fileList;
};